import { Env } from '@/consts/Env';

const getEnvironment = () => Env.NEXT_PUBLIC_ENVIRONMENT;

export const isStaging = () => getEnvironment() === 'staging';
export const isProduction = () => getEnvironment() === 'production';
